function initializeDeliveryDatePicker() {
    const radioButtons = document.querySelectorAll('input[name="attributes[Region]"]');
    const titleBox = document.querySelector('#calendar__box .title_box_cart');
    const dateInput = document.getElementById("delivery_date");
    const calendarContainer = document.getElementById("calendar__box");
    const checkoutButton = document.querySelector("#checkout-button");
    const preButton = document.getElementById("pre-checkout-button");
    const popup = document.querySelector(".popup_checkout_popup");
    
    preButton.disabled = true;
  
    if (!dateInput || !calendarContainer) return;

    if (dateInput.disabled) {
        dateInput.disabled = false;
    }
  
    calendarContainer.style.height = "0px"; 
    calendarContainer.style.opacity = "0";

    function getNewZealandTime() {
        const now = new Date();
        return new Date(now.toLocaleString("en-US", { timeZone: "Pacific/Auckland" }));
    }

    const now = getNewZealandTime();
    const currentHour = now.getHours();
    const currentDay = now.getDay();

    function getNextValidWeekday(daysToSkip = 1) {
        // let nextDate = new Date();
        // nextDate.setDate(now.getDate() + daysToSkip);
        const nextDate = new Date(now.getTime()); 
        nextDate.setDate(nextDate.getDate() + daysToSkip);

        while (nextDate.getDay() === 0 || nextDate.getDay() === 6) { 
            nextDate.setDate(nextDate.getDate() + 1);
        }
        return nextDate;
    }
  

    function updateAvailableDates() {

        calendarContainer.style.height = "auto";
        calendarContainer.style.opacity = "1";

        const selectedOption = document.querySelector('input[name="attributes[Region]"]:checked').value;

        const allowedDays = {
            "Auckland": [1, 2, 3, 4, 5], 
            "Hamilton": [1, 3, 5], 
            "Bay of Plenty": [1, 4], 
            "Other Areas": [1, 2, 3, 4, 5], 
            "Pick Up": [1, 2, 3, 4, 5] 
        };

        let minDate = getNextValidWeekday(1);

        if (currentHour >= 12 && selectedOption !== "other_areas") {
            minDate = getNextValidWeekday(2);
        }
        if (selectedOption === "other_areas") {
            minDate = currentHour < 20 ? getNextValidWeekday(2) : getNextValidWeekday(3);
        }
        
        const calendarBox = document.getElementById('calendar__box');

        const disabledDates = calendarBox.dataset.disabledDates
          .split(',')
          .map(date => date.trim())
          .filter(date => date.length > 0);
        
        console.log(disabledDates);
        // const disabledDates = ["2025-06-02", "2025-06-20"];
        flatpickr("#calendar-container", {
            inline: true,
            dateFormat: "Y-m-d",
            locale: {
                firstDayOfWeek: 1, 
                weekdays: {
                    shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], 
                    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
                },
                months: {
                    shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                }
            },
            minDate: minDate,
            enable: [
                // function (date) {
                //     return allowedDays[selectedOption].includes(date.getDay());
                // }
                function (date) {
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, '0');
                  const day = String(date.getDate()).padStart(2, '0');
                  const formattedDate = `${year}-${month}-${day}`;
              
                  return (
                    allowedDays[selectedOption].includes(date.getDay()) &&
                    !disabledDates.includes(formattedDate)
                  );
                }
              
            ],
            onChange: function (selectedDates, dateStr) {
                dateInput.value = dateStr;
                document.querySelector('input[name="attributes[Delivery Date]"]').value = dateStr;
                console.log(dateStr,'dateStr');
                if (dateStr) {
                    preButton.disabled = false;
                } else {
                    preButton.disabled = true;
                }
            }
        });
    }

    radioButtons.forEach(button => {
      console.log(333);
        button.addEventListener("change", updateAvailableDates);
    });

    function handleSubmit(event) {
        const selectedArea = document.querySelector('input[name="attributes[Region]"]:checked');
        if (!dateInput.value.trim() || !selectedArea || selectedArea.value === '') {
            event.preventDefault(); 
            alert("Please select a delivery date before checkout!"); 
            return;
        }

        localStorage.setItem('deliveryDate', dateInput.value);
      
        // preButton.disabled = false;
        popup.classList.add("open"); 
        event.preventDefault();
        return;
        
    }

    preButton.addEventListener("click", handleSubmit);
    preButton.addEventListener("touchend", handleSubmit);

    const close = document.querySelector(".popup_checkout_popup .close");
    close.addEventListener("click", function (event) {
        popup.classList.remove("open");
    });

    checkoutButton.addEventListener("click", function (event) {
        popup.classList.remove("open");
    });
}


// Initial execution when the page loads
document.addEventListener("DOMContentLoaded", initializeDeliveryDatePicker);

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    document.querySelectorAll(".paying_with square-placement").forEach(el => {
      el.shadowRoot?.querySelectorAll(".afterpay-main-text").forEach(textEl => textEl.style.display = "none");
      el.shadowRoot?.querySelectorAll(".afterpay-link").forEach(textEl => textEl.style.display = "none");
    });

    document.querySelectorAll("img.zip-logo").forEach(img => {
      img.src = "https://chickennthings.co.nz/cdn/shop/t/5/assets/zip-button-wht.svg";
    });
    
  }, 1000);
  
});
